module.exports = ".input-width {\n    width: 284px;\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/editclearJtransactions/editclearJtransactions.component.css
// module id = ./src/app/editclearJtransactions/editclearJtransactions.component.css
// module chunks = main